import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import icon_img from "../../images/logo.png";
import { fontSize } from "../../styles";
import { history } from "../../index";
import { verifyUserAccount } from "../../service/logic";
import { BackgroundCarousel, useWindowDimensions } from "../common";

const useStyles = makeStyles((theme) => ({
  bgContainer: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    zIndex: -2,
  },
  backgroundCanvas: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
    zIndex: -2,
  },
  backgroundGreyCanvas: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#c8c8c8",
    overflow: "hidden",
    zIndex: -3,
  },
  logo: {
    width: 330,
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    [theme.breakpoints.down("xs")]: {
      width: "55%",
    },
    marginTop: 50,
    marginBottom: 50,
  },
  paper: {
    height: "100vh",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      padding: 30,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "50px 10px",
      alignItems: "flex-start",
    },
    padding: 50,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
  bgClinic: {
    width: "66%",
    position: "absolute",
    marginLeft: "50%",
    marginTop: "10%",
  },
  form: {
    marginTop: -10,
    width: "95%",
    color: "#1D3557",
    paddingBottom: 20,
    [theme.breakpoints.down("sm")]: {
      width: "88%",
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 10,
      width: "62%",
    },
  },
  input: {
    color: "#1D3557",
    "&:hover": {
      color: "#457B9D",
    },
  },
  buttonContainer: {
    textAlign: "center",
  },
  submit: {
    marginTop: 30,
    paddingLeft: 75,
    paddingRight: 75,
    backgroundColor: "#1D3557",
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: fontSize.h4,
    "&:hover": {
      backgroundColor: "#457B9D",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 55,
      paddingRight: 55,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  imageHolder: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
    marginTop: "5vh",
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function VerifyAccount() {
  const query = useQuery();
  const token = query.get("token");
  const classes = useStyles();

  const [verified, setVerified] = useState(false);

  /** @type {HTMLCanvasElement} */
  const canvasRef = React.useRef(null);
  const { height, width } = useWindowDimensions();
  React.useEffect(() => {
    verifyUserAccount(token).then((result) => {
      if (result && !result.error) {
        setVerified(true);
      }
    });

    const canvas = canvasRef.current;
    if (canvas === null) return;
    /** @type {CanvasRenderingContext2D}*/
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#457B9D";
    ctx.rotate(0.167 * Math.PI);
    ctx.fillRect(
      -ctx.canvas.width / 2,
      -ctx.canvas.height * 1.55,
      ctx.canvas.width,
      ctx.canvas.height * 2
    );
    ctx.save();
    ctx.fillStyle = "#FFFFFF";
    ctx.rotate(-0.333 * Math.PI);
    ctx.fillRect(
      -ctx.canvas.width * 0.88,
      -ctx.canvas.width * 0.2,
      ctx.canvas.width * 1.2,
      3000
    );
    ctx.save();
  }, [canvasRef, token, width, height]);

  const isIpad = width / height === 768 / 1024;
  const isIpadPro = width / height === 1024 / 1366;

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.backgroundGreyCanvas} />
      <div className={classes.bgContainer}>
        <BackgroundCarousel />
      </div>
      <canvas
        className={classes.backgroundCanvas}
        ref={canvasRef}
        width={window.innerWidth}
        height={window.innerHeight}
      />
      <div
        className={classes.paper}
        style={{
          justifyContent: isIpadPro || isIpad ? "center" : "flex-start",
        }}
      >
        <div className={classes.imageHolder}>
          <img
            className={classes.logo}
            src={icon_img}
            alt={"Virtual Patient"}
          />
        </div>
        <form className={classes.form} noValidate>
          {verified ? (
            <>
              <Typography variant="h2" style={{ color: "black" }}>
                Congratulations, your account has been verified!
              </Typography>
              <Typography variant="h4" style={{ marginTop: 20 }}>
                Please continue to login page.
              </Typography>
              <div className={classes.buttonContainer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    history.push("/login");
                  }}
                  style={{ textTransform: "none " }}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <Typography variant="h3" style={{ color: "red" }}>
              Account verification failed, please try again. If you still
              encounter the same issue, please inform your lecturers to verify
              your account.
            </Typography>
          )}
        </form>
      </div>
    </React.Fragment>
  );
}
